import { ContentSegment } from '../../entity';

type ContentModuleSlotType = ContentSegment['type'];

type PageTemplate = {
  name: string;
  contentModuleOrder: ContentModuleSlotType[];
};

const pageTemplates = {
  trainstation: {
    name: 'trainstation',
    // Ratgeber Linking Module comes last but is not created in Contentful yet.
    contentModuleOrder: [
      'priceGraph',
      'destination',
      'stationsMap',
      'standardContent',
      'customerReviews',
      'textImage',
      'faqs',
    ],
  },
} satisfies Record<string, PageTemplate>;

type PageTemplateName = keyof typeof pageTemplates;

export { pageTemplates };
export type { PageTemplate, PageTemplateName, ContentModuleSlotType };
